import React from "react";
import {
  Box,
  Typography,
  Card,
  CardContent,
  Button,
  Grid,
  CardMedia,
  useTheme,
  Container,
} from "@mui/material";
import StarIcon from "@mui/icons-material/Star";
import basicImg from "../../../Assets/Images/Diamond.jpeg"; // Make sure you have these images in your project
import standardImg from "../../../Assets/Images/Gold.jpeg";
import premiumImg from "../../../Assets/Images/Silver.jpeg";
import { tokens } from "../../../theme";

const plans = [
  {
    title: "Basic",
    price: "$8.99",
    features: [
      "Unlimited System Users",
      "Role-based Privileges",
      "Security and Privacy",
    ],
    image: basicImg,
  },
  {
    title: "Standard",
    price: "$13.99",
    features: [
      "Unlimited System Users",
      "Role-based Privileges",
      "Security and Privacy",
      "Exportation of Reports",
    ],
    image: standardImg,
  },
  {
    title: "Premium",
    price: "$17.99",
    features: [
      "Unlimited System Users",
      "Role-based Privileges",
      "Security and Privacy",
      "Exportation of Reports",
      "Access from Multiple Branches",
    ],
    image: premiumImg,
  },
];

const SubscriptionPlans = () => {
  const Theme = useTheme();
  const colors = tokens(Theme.palette.colors);
  return (
    <Container className="mt-20" id="SubscriptionPlans" sx={{ mt: 5 }}>
      <Box textAlign="center" mb={3}>
        <Box
          component="span"
          variant="h2"
          mt={10}
          bgcolor="primary.main"
          color="secondary.main"
          p={1}
          borderRadius="8px"
          display="inline-block"
          fontSize="x-large"
        >
          Choose Your Subscription Plans
        </Box>
      </Box>
      <Grid container spacing={4} justifyContent="center">
        {plans.map((plan, index) => (
          <Grid item key={index} xs={12} md={4}>
            <Card
              sx={{
                maxWidth: 345,
                boxShadow: 3,
                transition: "transform 0.3s",
                "&:hover": {
                  transform: "scale(1.05)",
                },
                bgcolor: colors.greenAccent[200],
              }}
            >
              <CardMedia
                component="img"
                height="140"
                image={plan.image}
                alt={plan.title}
              />
              <CardContent>
                <Typography
                  variant="h5"
                  align="center"
                  sx={{ fontWeight: "bold", color: colors.greenAccent[400] }}
                >
                  {plan.title}
                </Typography>
                <Typography
                  variant="h6"
                  align="center"
                  sx={{ color: colors.blueAccent[700], mb: 2 }}
                >
                  {plan.price}
                </Typography>
                <Box sx={{ mt: 2 }}>
                  {plan.features.map((feature, idx) => (
                    <Box
                      key={idx}
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        mb: 1,
                      }}
                    >
                      <StarIcon color={`${colors.primary}`} sx={{ mr: 1 }} />
                      <Typography variant="body1" align="left">
                        {feature}
                      </Typography>
                    </Box>
                  ))}
                </Box>
                <Box sx={{ mt: 4, display: "flex", justifyContent: "center" }}>
                  <Button
                    variant="contained"
                    color="primary"
                    sx={{ textTransform: "none", fontWeight: "bold" }}
                  >
                    Choose {plan.title}
                  </Button>
                </Box>
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>
    </Container>
  );
};

export default SubscriptionPlans;
